import { YardIssueType } from '@yard/app/api'
import { YardIssueDto } from '../models/yard-issue.model'

export interface ImdgIssuePresentation {
  titleKey: string
  titleFallback: string
  detailKey: string
  detailFallback: string
  detailParams: Record<string, string | number>
}

export const formatImoClassLabel = (imoClass?: string | null) => {
  if (!imoClass) return 'Class unknown'
  return `Class ${imoClass}`
}

export const isImdgIssueType = (issueType: string) => {
  return (
    issueType === YardIssueType.ImdgSegregationViolation ||
    issueType === YardIssueType.ImdgStackingOnTopViolation ||
    issueType === YardIssueType.ImdgTierCapViolation
  )
}

export const getImdgIssuePresentation = (issue: YardIssueDto): ImdgIssuePresentation | null => {
  switch (issue.issueType) {
    case YardIssueType.ImdgSegregationViolation:
      if (issue.isProhibited) {
        return {
          titleKey: 'imdgSegregationViolation',
          titleFallback: 'IMDG segregation violation',
          detailKey: 'imdgSegregationProhibitedDetail',
          detailFallback:
            '{placedClass} and {conflictingClass} cannot be placed in the same yard block under the current DG segregation rules.',
          detailParams: {
            placedClass: formatImoClassLabel(issue.placedImoClass),
            conflictingClass: formatImoClassLabel(issue.conflictingImoClass),
          },
        }
      }

      return {
        titleKey: 'imdgSegregationViolation',
        titleFallback: 'IMDG segregation violation',
        detailKey: 'imdgSegregationViolationDetail',
        detailFallback:
          '{placedClass} conflicts with {conflictingClass}. Required separation: {requiredDistance} ft.',
        detailParams: {
          placedClass: formatImoClassLabel(issue.placedImoClass),
          conflictingClass: formatImoClassLabel(issue.conflictingImoClass),
          requiredDistance: issue.requiredDistance ?? 'unknown',
        },
      }
    case YardIssueType.ImdgStackingOnTopViolation:
      return {
        titleKey: 'imdgStackingOnTopViolation',
        titleFallback: 'IMDG stacking violation',
        detailKey: 'imdgStackingOnTopViolationDetail',
        detailFallback:
          'Stacking on top of {belowClass} is not allowed by the current DG stacking rules.',
        detailParams: {
          belowClass: formatImoClassLabel(issue.prohibitedBelowImoClass),
        },
      }
    case YardIssueType.ImdgTierCapViolation:
      return {
        titleKey: 'imdgTierCapViolation',
        titleFallback: 'IMDG tier cap violation',
        detailKey: 'imdgTierCapViolationDetail',
        detailFallback: '{imoClass} may only be stacked up to tier {maxTiers}.',
        detailParams: {
          imoClass: formatImoClassLabel(issue.violatingImoClass),
          maxTiers: issue.maxTiersValue ?? 'unknown',
        },
      }
    default:
      return null
  }
}
